import {
    Box,
    FormControl,
    FormLabel,
    Input,
    Select,
    SimpleGrid,
    Text,
} from "@chakra-ui/react";

interface ApplicationFieldsProps {
    fields: any[];
    values: any;
    setValues: (values: any) => void;
}

const ApplicationFields = ({
    fields,
    values,
    setValues,
}: ApplicationFieldsProps) => {
    const handleValueChange = (fieldId: string, value: any) => {
        setValues({
            ...values,
            [fieldId]: value,
        });
    };

    // Group fields by section
    const fieldsBySection = fields.reduce((acc: any, field: any) => {
        const sectionId = field.section?.id || "no-section";
        if (!acc[sectionId]) {
            acc[sectionId] = {
                section: field.section,
                fields: [],
            };
        }
        acc[sectionId].fields.push(field);
        return acc;
    }, {});

    return (
        <Box>
            {Object.entries(fieldsBySection).map(
                ([sectionId, section]: [string, any]) => (
                    <Box key={sectionId} mb={6}>
                        {section.section && (
                            <Text fontSize="lg" fontWeight="500" mb={4}>
                                {section.section.section_name}
                            </Text>
                        )}
                        <SimpleGrid columns={2} spacing={4}>
                            {section.fields.map((field: any) => (
                                <FormControl
                                    key={field.id}
                                    isRequired={field.required}
                                >
                                    <FormLabel>{field.label}</FormLabel>
                                    {field.type === "text" && (
                                        <Input
                                            value={values[field.id] || ""}
                                            onChange={(e) =>
                                                handleValueChange(
                                                    field.id,
                                                    e.target.value
                                                )
                                            }
                                            placeholder={field.placeholder}
                                        />
                                    )}
                                    {field.type === "number" && (
                                        <Input
                                            type="number"
                                            value={values[field.id] || ""}
                                            onChange={(e) =>
                                                handleValueChange(
                                                    field.id,
                                                    e.target.value
                                                )
                                            }
                                            placeholder={field.placeholder}
                                        />
                                    )}
                                    {field.type === "dropdown" && (
                                        <Select
                                            value={values[field.id] || ""}
                                            onChange={(e) =>
                                                handleValueChange(
                                                    field.id,
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="">Select...</option>
                                            {field.options?.map(
                                                (option: string) => (
                                                    <option
                                                        key={option}
                                                        value={option}
                                                    >
                                                        {option}
                                                    </option>
                                                )
                                            )}
                                        </Select>
                                    )}
                                    {field.type === "date" && (
                                        <Input
                                            type="date"
                                            value={values[field.id] || ""}
                                            onChange={(e) =>
                                                handleValueChange(
                                                    field.id,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    )}
                                    {field.type === "percentage" && (
                                        <Input
                                            type="number"
                                            step="0.01"
                                            value={values[field.id] || ""}
                                            onChange={(e) =>
                                                handleValueChange(
                                                    field.id,
                                                    e.target.value
                                                )
                                            }
                                            placeholder={
                                                field.placeholder || "0.00%"
                                            }
                                        />
                                    )}
                                    {field.type === "dollar" && (
                                        <Input
                                            type="number"
                                            step="0.01"
                                            value={values[field.id] || ""}
                                            onChange={(e) =>
                                                handleValueChange(
                                                    field.id,
                                                    e.target.value
                                                )
                                            }
                                            placeholder={
                                                field.placeholder || "$0.00"
                                            }
                                        />
                                    )}
                                </FormControl>
                            ))}
                        </SimpleGrid>
                    </Box>
                )
            )}
        </Box>
    );
};

export default ApplicationFields;
